import { toUUID } from '../../util/transform';
import type { ITicketContactType } from './TicketContactType.interface';

export default class TicketContactType {
  idContact: string;
  idLabel: string;

  static build = (data: ITicketContactType) => new TicketContactType(data);
  static blank = () => new TicketContactType();

  /**
   * Constructor
   * @param {ITicketContactType} data
   */
  constructor(data?: ITicketContactType) {
    this.idContact = toUUID(data?.idContact);
    this.idLabel = toUUID(data?.idLabel);
  }
}
